import { statusAndResponse } from "../../../../util/requestHandler";
import { Api, decryptApiResponse } from "../../../../config/Api";

export const getRealTimeClients = () => {
  return statusAndResponse(
    Api.get(`/api/v2/iv/realtime/clients`),
    decryptApiResponse,
  );
};

export const handleDownloadReport = async (request) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    responseType: "blob",
  };
  return statusAndResponse(
    Api.post("/api/v2/iv/realtime/downloadverifications", request, config),
    decryptApiResponse,
  );
};
